import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M15.98 6 9 12.77V8H6v10h10v-3h-4.85L18 8.03z"
}), 'TransitEnterexitTwoTone');